// Timeline Process - Scroll Animation
document.addEventListener('DOMContentLoaded', function() {
  const timeline = document.querySelector('.timeline-wrapper');
  const activeLine = document.querySelector('.timeline-line-active');
  const steps = document.querySelectorAll('.timeline-step');

  if (!timeline || !activeLine || steps.length === 0) return;

  function handleScroll() {
    const timelineTop = timeline.getBoundingClientRect().top;
    const windowHeight = window.innerHeight;
    const triggerPoint = windowHeight * 0.5;

    const scrollProgress = Math.max(0, triggerPoint - timelineTop);
    activeLine.style.height = `${Math.max(0, scrollProgress)}px`;

    let hasActiveStep = false;

    steps.forEach((step, index) => {
      const stepTop = step.getBoundingClientRect().top;
      const stepMiddle = stepTop + step.offsetHeight / 2;

      if (stepMiddle < triggerPoint) {
        step.classList.add('active');
        hasActiveStep = true;
      } else {
        step.classList.remove('active');
      }
    });

    if (!hasActiveStep && steps.length > 0) {
      steps[0].classList.add('active');
    }
  }

  window.addEventListener('scroll', handleScroll);
  handleScroll();
});
